import { WSTableCell, WSTableColumn } from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { PayeeEngagementType, WorkLog } from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { WorkLogPayerStatusCell } from "../../../WorkLogs/components/WorkLogPayerStatusCell";
import { PAYROLL_CURRENCY } from "../../constants";

import { EmployeeCell } from "./EmployeeCell";

export const getColumns = (): WSTableColumn<WorkLog>[] => [
  {
    config: { gridTemplateSizeMax: "1fr", header: { text: "Employee" } },
    renderFunction: rowItem => (
      <EmployeeCell payeeEngagementId={rowItem.data.payeeEngagementId} />
    )
  },
  {
    config: { gridTemplateSizeMax: "0.6fr", header: { text: "Work log #" } },
    renderFunction: rowItem => (
      <WSTableCell text={rowItem.data.workLogNumber ?? "-"} />
    )
  },
  {
    config: { gridTemplateSizeMax: "0.5fr", header: { text: "Hours" } },
    renderFunction: rowItem => (
      <WSTableCell
        text={
          rowItem.data.totalHours === undefined
            ? "-"
            : `${rowItem.data.totalHours}`
        }
      />
    )
  },
  {
    config: { gridTemplateSizeMax: "0.8fr", header: { text: "Status" } },
    // Every work log on a payroll run is an employee's, so the status copy is
    // pinned to the W-2 wording rather than falling back to "invoice".
    renderFunction: rowItem => (
      <WorkLogPayerStatusCell
        engagementType={PayeeEngagementType.EMPLOYEE}
        workLog={rowItem.data}
      />
    )
  },
  {
    config: {
      gridTemplateSizeMax: "0.6fr",
      justify: "end",
      header: { text: "Amount" }
    },
    renderFunction: rowItem => (
      <WSTableCell
        text={formatMoney(rowItem.data.totalAmount ?? 0, PAYROLL_CURRENCY)}
      />
    )
  }
];
